import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { X } from 'lucide-react';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function VideoModal({ isOpen, onClose }: VideoModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[800px] p-0 bg-black border-0">
        <DialogHeader className="sr-only">
          <DialogTitle>Eyes Montessori London Kains Demo Video</DialogTitle>
          <DialogDescription>
            Watch our demo video to see how Eyes Montessori London Kains makes learning fun and engaging for children
          </DialogDescription>
        </DialogHeader>
        
        <div className="relative aspect-video">
          <Button
            variant="ghost"
            size="icon"
            className="absolute -top-12 right-0 text-white hover:bg-white/10 z-10"
            onClick={onClose}
          >
            <X className="w-6 h-6" />
          </Button>
          
          {/* Embedded YouTube video - replace with actual demo video URL */}
          <iframe
            className="w-full h-full rounded-lg"
            src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=0&rel=0&modestbranding=1"
            title="Eyes Montessori London Kains Demo Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
          
          {/* Fallback content if video doesn't load */}
          <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-purple-500 flex items-center justify-center text-white text-center rounded-lg">
            <div>
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-0 h-0 border-l-6 border-l-white border-t-4 border-t-transparent border-b-4 border-b-transparent ml-1"></div>
              </div>
              <h3 className="text-xl font-bold mb-2">Watch Our Demo</h3>
              <p className="text-white/80">See how Eyes Montessori London Kains makes learning fun and engaging for children</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}